import { Scissors, Instagram, Facebook, Twitter, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-barber-950 text-white !m-0">
      <div className="section-container pt-12 !pb-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Logo & About */}
          <div className="bg-barber-900 rounded-3xl border border-barber-800 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <Scissors size={24} className="text-barber-300" />
                <span className="text-2xl font-display font-bold tracking-tight">ELITE CUTS</span>
              </div>
              <p className="text-barber-300 text-sm">
                Premier barbershop specializing in precision cuts, beard styling, and grooming services for the modern gentleman.
              </p>
              <div className="flex space-x-4 pt-2">
                <a href="#" className="text-barber-300 hover:text-white transition-colors">
                  <Instagram size={20} />
                  <span className="sr-only">Instagram</span>
                </a>
                <a href="#" className="text-barber-300 hover:text-white transition-colors">
                  <Facebook size={20} />
                  <span className="sr-only">Facebook</span>
                </a>
                <a href="#" className="text-barber-300 hover:text-white transition-colors">
                  <Twitter size={20} />
                  <span className="sr-only">Twitter</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="bg-barber-900 rounded-3xl border border-barber-800 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-barber-300 hover:text-white transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#team" className="text-barber-300 hover:text-white transition-colors">
                  Our Team
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-barber-300 hover:text-white transition-colors">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-barber-300 hover:text-white transition-colors">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-barber-300 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="bg-barber-900 rounded-3xl border border-barber-800 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Precision Haircut
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Beard Styling
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Hot Towel Shave
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Color & Highlights
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Kids Haircut
                </a>
              </li>
              <li>
                <a href="#services" className="text-barber-300 hover:text-white transition-colors">
                  Grooming Products
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="bg-barber-900 rounded-3xl border border-barber-800 p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <address className="not-italic text-barber-300 space-y-2">
              <p>123 Main Street, Downtown</p>
              <p>New York, NY 10001</p>
              <p className="pt-2">(212) 555-1234</p>
              <p>
                <a href="mailto:info@elitecuts.com" className="hover:text-white transition-colors">
                  info@elitecuts.com
                </a>
              </p>
            </address>
          </div>
        </div>

        <div className="border-t border-barber-800 mt-8 pt-6 pb-2">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <p className="text-barber-400 text-sm">
              © {currentYear} Elite Cuts Barbershop. All rights reserved.
            </p>
            <p className="text-white/50 text-sm font-mono">
              Made with{' '}
              <Heart size={16} className="inline text-white/50 animate-pulse" /> by{' '}
              <a
                href="https://digitalpro.dev/"
                className="text-white/80 hover:text-white hover:underline transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                DigitalPro
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;